export enum RegistrationModelSerialStatus {
  CodeExpired = 'CODE_EXPIRED',
  Complete = 'COMPLETE',
  Pending = 'PENDING',
}
